module.exports = __webpack_public_path__ + "img/202112-dark.01aab984.png";